import React, { useRef } from "react";
import Style from "./CustomerInformation.module.css";

const CustomerInformation = ({ secondDestinationState, dispatch }) => {
  const senderInfo = useRef({});
  const resiverInfo = useRef({});
  const resiver2Info = useRef({});

  const setDataHandler = (type, values) => {
    switch (type) {
      case 'sender':
        senderInfo.current = { ...senderInfo.current, [values.name]: values.value };
        dispatch({ type: "SET_SENDER_INFORMATION", payload: senderInfo.current });
        break;
      case 'resiver':
        resiverInfo.current = { ...resiverInfo.current, [values.name]: values.value };
        dispatch({ type: "SET_RESIVER_INFORMATION", payload: resiverInfo.current });
        break;
      case 'resiver2':
        resiver2Info.current = { ...resiver2Info.current, [values.name]: values.value };
        dispatch({ type: "SET_RESIVER2_INFORMATION", payload: resiver2Info.current });
        break;
      default:
        break;
    }
  };

  return (
    <section className={Style.componentHolder}>
      <div>
        <h5>اطلاعات فرستنده</h5>
        <div className={Style.InputHolder} onChange={(e) => setDataHandler("sender", e.target)}>
          <input type="text" name="senderName" placeholder="نام و نام خانوادگی فرستنده" />
          <input type="tel" name="senderPhone" placeholder="شماره تماس فرستنده" maxLength={11} />
          <input type="text" name="senderDescription" placeholder="توضیحات آدرس مبدا" />
        </div>
      </div>
      <div>
        <h5>اطلاعات گیرنده</h5>
        <div className={Style.InputHolder} onChange={(e) => setDataHandler("resiver", e.target)}>
          <input type="text" name="resiverName" placeholder="نام و نام خانوادگی گیرنده" />
          <input type="tel" name="resiverPhone" placeholder="شماره تماس گیرنده" maxLength={11} />
          <input type="text" name="resiverDescription" placeholder="توضیحات مقصد گیرنده" />
        </div>
      </div>
      {secondDestinationState && (
        <div>
          <h5>اطلاعات گیرنده دوم</h5>
          <div className={Style.InputHolder} onChange={(e) => setDataHandler("resiver2", e.target)}>
            <input type="text" name="resiver2Name" placeholder="نام و نام خانوادگی گیرنده دوم" />
            <input type="tel" name="resiver2Phone" placeholder="شماره تماس گیرنده دوم" maxLength={11} />
            <input type="text" name="resiver2Description" placeholder="توضیحات مقصد گیرنده دوم" />
          </div>
        </div>
      )}
    </section>
  );
};

export default CustomerInformation;
